// src/pages/ZezeninBahcesiPage.jsx
import React from 'react';
import TopBar from '../components/TopBar';
import NavBar from '../components/NavBar';
import AboutSection from '../components/AboutSection';
import Footer from '../components/Footer';

export default function Kurumsal() {
  return (
    <>
      <TopBar />
      <NavBar />
      <AboutSection /> 
      <Footer />
    </>
  );
}
